import { Chip } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

export const PrimaryAccountChip = () => {
  const { t } = useResource();

  return (
    <Chip
      component="span"
      label={t(Resources.Components.Account.Primary)}
      variant="outlined"
      size="small"
    />
  );
};
